export class NewSubscription {

  proofId: number;
  proofName: string;
  modalityId: number;
  kind: string;
  accessKind: string;
  camera: boolean;
  price: string;
  priceName: string;
  affiliatedFederalCode: string;
  courseCode: string;
  //  Payment method
  public paymentMode: string; //default
  public paymentMethod: string; //boleto
  public currency: string; //BRL
  public extraAmount: string; //0.00
  public itemId1: string; //0001
  public itemDescription1: string; //Notebook Prata
  public itemAmount1: string; //24300.00
  public itemQuantity1: string; //1
  public notificationURL: string; //https://sualoja.com.br/notifica.html
  public reference: string; //REF1234
  public senderName: string; //
  public senderCPF: string; //72962940005
  public senderCNPJ: string; //72962940005
  public federalCode: string; //72962940005
  public senderAreaCode: string; //11
  public senderPhone: string; //56273440
  public senderEmail: string; //comprador@uol.com.br
  public senderHash: string; //{{hash_do_comprador}}
  public shippingAddressRequired: boolean; //false
  public email: string;
  public token: string;
  public sessionIdPS: string;
  public applicationId: number;
  public creditCardToken: string;
  // public creditCardNum: number;
  // public creditCardCvv: number;
  // public creditCardMonthExp: number;
  // public creditCardYearExp: number;
  // public cardBrand: number;
  // public cardBrands: string;
  // INSTALLMENTS
  public installment: any;

  public voucherId;
  public voucherDiscountTotal;
  public voucherCode;
  public discountAmount: any;

  public userAggregateAffiliatedFederalCode: any;

  constructor() {
    this.proofId = null;
    this.proofName = null;
    this.modalityId = null;
    this.kind = null;
    this.accessKind = null;
    this.camera = null;
    this.affiliatedFederalCode = null;
    this.courseCode = null;
    //  Payment method
    this.paymentMode = null;
    this.paymentMethod = null;
    this.currency = null;
    this.extraAmount = null;
    this.itemId1 = null;
    this.itemDescription1 = null;
    this.itemAmount1 = null;
    this.itemQuantity1 = null;
    this.notificationURL = null;
    this.reference = null;
    this.senderName = null;
    this.senderCPF = null;
    this.senderCNPJ = null;
    this.federalCode = null;
    this.senderAreaCode = null;
    this.senderPhone = null;
    this.senderEmail = null;
    this.senderHash = null;
    this.shippingAddressRequired = null;
    this.email = null;
    this.token = null;
    this.sessionIdPS = null;
    this.applicationId = null;
    this.creditCardToken = null;
    this.price = null;
    this.priceName = null;
    // this.creditCardNum = null;
    // this.creditCardCvv = null;
    // this.creditCardMonthExp = null;
    // this.creditCardYearExp = null;
    // this.cardBrand = null;
    // this.cardBrands = null;

    // INSTALLMENTS
    this.installment = null;

    this.voucherId = null;
    this.voucherCode = null;
    this.voucherDiscountTotal = 0;
    this.discountAmount = 0;

    this.userAggregateAffiliatedFederalCode = null;

  }

}



// WEBPACK FOOTER //
// ./src/models/newsubscription.ts